import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const daysOfWeek = [
  'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
];

const timeOptions = [
  '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM',
  '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM',
  '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM'
];

const VendorSignUpNext = () => {
  const [services, setServices] = useState([]);
  const [serviceDetails, setServiceDetails] = useState({});
  const [selectedDetails, setSelectedDetails] = useState({});
  const [availability, setAvailability] = useState({});
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Get selectedDetails from localStorage (set in VendorSignupFull)
    const stored = localStorage.getItem('selectedDetails');
    setSelectedDetails(stored ? JSON.parse(stored) : {});

    // Fetch all services
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/services`)
      .then(res => res.json())
      .then(data => setServices(data));

    // Fetch all service details for each service
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/service_details/all`)
      .then(res => res.json())
      .then(data => {
        const detailsByService = {};
        data.forEach(detail => {
          if (!detailsByService[detail.service_id]) detailsByService[detail.service_id] = [];
          detailsByService[detail.service_id].push(detail);
        });
        setServiceDetails(detailsByService);
      });

    // Restore availability from localStorage if present
    const storedAvailability = localStorage.getItem('availability');
    if (storedAvailability) {
      setAvailability(JSON.parse(storedAvailability));
    }
  }, []);

  // Initialize availability for each selected detail if not present
  useEffect(() => {
    setAvailability(prev => {
      const newAvailability = { ...prev };
      Object.keys(selectedDetails).forEach(serviceId => {
        selectedDetails[serviceId].forEach(detailId => {
          if (!newAvailability[detailId]) {
            newAvailability[detailId] = {};
            daysOfWeek.forEach(day => {
              newAvailability[detailId][day] = { start: '', end: '' };
            });
          } else {
            // Ensure all days exist
            daysOfWeek.forEach(day => {
              if (!newAvailability[detailId][day]) {
                newAvailability[detailId][day] = { start: '', end: '' };
              }
            });
          }
        });
      });
      return newAvailability;
    });
  }, [selectedDetails]);

  const handleAvailabilityChange = (detailId, day, field, value) => {
    setAvailability(prev => ({
      ...prev,
      [detailId]: {
        ...prev[detailId],
        [day]: {
          ...((prev[detailId] && prev[detailId][day]) || {}),
          [field]: value
        }
      }
    }));
  };

  const parseTime = (timeStr) => {
    // Converts "6:00 AM" to minutes since midnight
    if (!timeStr) return null;
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    return hours * 60 + minutes;
  };

  const validateTimes = () => {
    let error = '';
    Object.keys(availability).forEach(detailId => {
      daysOfWeek.forEach(day => {
        const start = availability[detailId][day]?.start;
        const end = availability[detailId][day]?.end;
        if (start && end) {
          const startMin = parseTime(start);
          const endMin = parseTime(end);
          if (endMin < startMin) {
            error = `End time for ${day} in "${detailId}" cannot be earlier than start time.`;
          }
          if (endMin === startMin) {
            error = `Start time and end time for ${day} in "${detailId}" cannot be the same.`;
          }
        }
      });
    });
    return error;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errorMsg = validateTimes();
    if (errorMsg) {
      setMessage(errorMsg);
      return;
    }
    // Save availability to localStorage for confirmation page
    localStorage.setItem('availability', JSON.stringify(availability));
    navigate('/vendorsignupconfirmation');
  };

  return (
    <div style={styles.container}>
      {/* Back button at the top */}
      <button
        style={{
          ...styles.button,
          background: '#388e3c',
          marginTop: 0,
          marginBottom: '18px',
          marginLeft: 0,
          marginRight: 'auto',
          display: 'inline-block',
        }}
        type="button"
        onClick={() => navigate('/vendorsignupfull')}
      >
        Back
      </button>
      <form onSubmit={handleSubmit}>
        <h2 style={styles.title}>Review & Set Pickup Time Slots for Selected Service Services</h2>
        <div style={styles.servicesSection}>
          {services.map(service => (
            selectedDetails[service.id] && selectedDetails[service.id].length > 0 && (
              <div key={service.id} style={styles.serviceCard}>
                <h4 style={styles.serviceName}>{service.name}</h4>
                <p style={styles.serviceDesc}>{service.description}</p>
                <div style={styles.detailsGrid}>
                  {serviceDetails[service.id] &&
                    serviceDetails[service.id]
                      .filter(detail => selectedDetails[service.id].includes(detail.id))
                      .map(detail => (
                        <div key={detail.id} style={styles.detailCard}>
                          <span style={{ fontWeight: 'bold', color: '#4078c0', fontSize: '1.08rem' }}>
                            {detail.name}
                          </span>
                          <p style={{ margin: '8px 0 0 0', color: '#555', fontSize: '0.98rem' }}>
                            {detail.description}
                          </p>
                   
                          {detail.image_url && (
                            <img
                              src={detail.image_url}
                              alt={detail.name}
                              style={{
                                width: '100%',
                                maxHeight: '120px',
                                objectFit: 'cover',
                                borderRadius: '6px',
                                marginTop: '10px',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                              }}
                            />
                          )}
                          <div style={{ marginTop: '14px' }}>
                            <h5 style={{ color: '#4078c0', fontSize: '1rem', marginBottom: '8px' }}>Pickup Time Slots</h5>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                              {daysOfWeek.map(day => (
                                <div
                                  key={day}
                                  style={{
                                    marginBottom: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    minHeight: '40px'
                                  }}
                                >
                                  <label
                                    style={{
                                      minWidth: '90px',
                                      fontWeight: 'bold',
                                      color: '#4078c0',
                                      textAlign: 'right'
                                    }}
                                  >
                                    {day}:
                                  </label>
                                  <select
                                    value={availability[detail.id]?.[day]?.start || ''}
                                    onChange={e => handleAvailabilityChange(detail.id, day, 'start', e.target.value)}
                                    style={{
                                      padding: '7px',
                                      borderRadius: '6px',
                                      border: '1px solid #ccc',
                                      fontSize: '0.98rem',
                                      flex: 1,
                                      minWidth: '120px'
                                    }}
                                  >
                                    <option value="">Start Time</option>
                                    {timeOptions.map(opt => (
                                      <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                  </select>
                                  <span style={{ fontWeight: 'bold', color: '#4078c0' }}>to</span>
                                  <select
                                    value={availability[detail.id]?.[day]?.end || ''}
                                    onChange={e => handleAvailabilityChange(detail.id, day, 'end', e.target.value)}
                                    style={{
                                      padding: '7px',
                                      borderRadius: '6px',
                                      border: '1px solid #ccc',
                                      fontSize: '0.98rem',
                                      flex: 1,
                                      minWidth: '120px'
                                    }}
                                  >
                                    <option value="">End Time</option>
                                    {timeOptions.map(opt => (
                                      <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                  </select>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      handleAvailabilityChange(detail.id, day, 'start', '');
                                      handleAvailabilityChange(detail.id, day, 'end', '');
                                    }}
                                    style={{
                                      padding: '6px 10px',
                                      borderRadius: '4px',
                                      border: '1px solid #d32f2f',
                                      background: '#fff',
                                      color: '#d32f2f',
                                      fontSize: '0.85rem',
                                      cursor: 'pointer',
                                      fontWeight: 'bold',
                                      minWidth: '50px',
                                      transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.background = '#d32f2f';
                                      e.target.style.color = '#fff';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.background = '#fff';
                                      e.target.style.color = '#d32f2f';
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
            )
          ))}
        </div>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginTop: '24px' }}>
          <button style={styles.button} type="submit">Confirm Selections</button>
        </div>
        {message && <div style={styles.message}>{message}</div>}
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  title: {
    marginBottom: '16px',
    color: '#4078c0',
    fontSize: '1.5rem',
    textAlign: 'center',
  },
  button: {
    padding: '10px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
    marginTop: '24px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
   hourlyRateInput: {
    width: '90px', // Slightly bigger rate box
    minWidth: '90px',
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '1.08rem',
    background: '#fff',
    boxShadow: '0 1px 4px #e0e0e0',
    textAlign: 'right',
  },
  message: {
    marginTop: '16px',
    color: '#4078c0',
    fontSize: '1rem',
    textAlign: 'center',
  },
  servicesSection: {
    marginTop: '40px',
  },
  serviceCard: {
    background: '#f5f6fa',
    borderRadius: '8px',
    padding: '18px',
    marginBottom: '24px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
  },
  serviceName: {
    color: '#4078c0',
    fontWeight: 'bold',
    fontSize: '1.15rem',
    marginBottom: '8px',
  },
  serviceDesc: {
    color: '#555',
    marginBottom: '8px',
  },
  detailsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)', // Two cards per row
    gap: '18px',
    marginTop: '12px',
  },
  detailCard: {
    background: '#fff',
    borderRadius: '8px',
    padding: '14px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    marginBottom: '0',
    minHeight: '120px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
};

export default VendorSignUpNext;